/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { action } from 'typesafe-actions';

import { OrderActionTypes, OrderData, OrderDataProps, orderListProps } from './types';

export function orderList(request: orderListProps, page?: number) {
  return action(OrderActionTypes.ORDER_LIST_REQUEST, { request, page });
}

export function orderListSuccess(order: OrderDataProps) {
  return action(OrderActionTypes.ORDER_LIST_SUCCESS, { order });
}

export function order(order_id: number) {
  return action(OrderActionTypes.ORDER_REQUEST, { order_id });
}

export function orderSucess(order: OrderData) {
  return action(OrderActionTypes.ORDER_SUCCESS, { order });
}

export function orderClear() {
  return action(OrderActionTypes.ORDER_CLEAR);
}

export function clearLoading() {
  return action(OrderActionTypes.CLEAR_LOADING);
}

export function orderCancelRequest(order_id: number) {
  return action(OrderActionTypes.ORDER_CANCEL_REQUEST, { order_id });
}
export function orderCancelSuccess(order: OrderData) {
  return action(OrderActionTypes.ORDER_CANCEL_SUCCESS, { order });
}



